import "./About.module.css";
import Header from "@/reusable_sections/Header";
import AboutHero from "./sections/AboutHero";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <AboutHero />
      <Footer />
    </div>;
}